import $axios from '~/plugins/axios';

import { Api, AuditLight, GetAuditParams, PaginatorResult } from '~/api';
import { buildModule, createPaginationModule } from '../utils';
import { Dict, createDict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withSubmodules({
		pagination: createPaginationModule({
			pageQueryKey: 'auditFormsPage',
			pageSizeQueryKey: 'auditFormsPerPage',
			itemCountGetter: 'auditForms/list/totalCount',
		}),
	})
	.withState({
		storedAuditForms: {} as Dict<AuditLight>,
		auditForms: [] as AuditLight[],
		paginator: null as PaginatorResult | null,
	})
	.withGetters({
		byId: state => (id: AuditLight['id']): AuditLight | null => (
			state.storedAuditForms[id] ?? null
		),
		page: state => state.auditForms,
		totalCount: state => state.paginator?.totalCount ?? 0,
	})
	.withMutations({
		SET_STORED_AUDIT_FORMS (state, auditForms: AuditLight[]) {
			state.storedAuditForms = {
				...state.storedAuditForms,
				...createDict(auditForms, ({ id }) => id),
			};
		},
		SET_AUDIT_FORMS (state, formIds: AuditLight['id'][]) {
			state.auditForms = formIds.map(id => state.storedAuditForms[id]);
		},
		SET_PAGINATOR (state, paginator: PaginatorResult) {
			state.paginator = paginator;
		},
	})
	.withActions({
		async get ({ commit }, params: Omit<GetAuditParams, 'auditType'> = {}) {
			const { data } = await api.get('/audit', { params: { ...params, auditType: 'form' } });

			const audits = data.payload;
			const auditIds = audits.map(({ id }) => id);

			commit('SET_STORED_AUDIT_FORMS', audits);
			commit('SET_AUDIT_FORMS', auditIds);
			commit('SET_PAGINATOR', data.paginator);
		},
	});
